export const runtime = {
  get isMiniApp(): boolean {
    const tg = window.Telegram?.WebApp;
    return !!tg && typeof tg.initData === 'string' && tg.initData.length > 0;
  },
  get isStandalone(): boolean {
    return !this.isMiniApp;
  },
  get isTouch(): boolean {
    return typeof window !== 'undefined' && 'ontouchstart' in window;
  },
  get isMobileViewport(): boolean {
    return typeof window !== 'undefined' && window.matchMedia('(max-width: 1023px)').matches;
  },
};
